export const CelebrationEffect = ({ showConfetti, celebrationType }) => {
  if (!showConfetti) return null;

  return (
    <>
      {/* Glitch scan lines - MORE AGGRESSIVE */}
      <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-lime-500 animate-glitch"
            style={{
              width: '100%',
              height: `${Math.random() * 4 + 2}px`,
              top: `${i * 3.33}%`,
              left: 0,
              opacity: Math.random() * 0.7 + 0.3,
              mixBlendMode: 'screen'
            }}
          />
        ))}
      </div>

      {/* Screen distortion overlay */}
      <div className="fixed inset-0 pointer-events-none z-50">
        <div className="w-full h-full animate-screen-distort" style={{
          background: 'repeating-linear-gradient(0deg, rgba(0,255,0,0.15) 0px, transparent 2px, transparent 4px)',
          mixBlendMode: 'overlay'
        }} />
      </div>

      {/* Celebration Message - CENTERED */}
      <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
        <div className="animate-glitch-message">
          <div className="bg-black border-4 sm:border-6 border-lime-500 px-6 sm:px-8 py-4 sm:py-6 shadow-2xl">
            <p className="text-lime-500 font-black text-2xl sm:text-4xl md:text-5xl uppercase tracking-wider text-center animate-rgb-split">
              {celebrationType === 'weekly' ? '🔥 WEEKLY SENT! 🔥' :
                celebrationType === 'recovery' ? '⚡ RECOVERY 2X! ⚡' :
                  '✓ SENT IT! ✓'}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
